import { types } from 'actions/shared'

export default function reducer (state = {}, action) {
  switch (action.type) {
    case types.SET_UPLOADER_OPTIONS:
      return action.data
  }
  return state
}